<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="saveMedicine">
        <mdb-modal side position="right" fullHeight direction="right" :show="modal" @close="close">
          <mdb-modal-header>
              <mdb-modal-title class="h4">Neue Bedarfsmedikation</mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body>
            <validation-provider
              name="Grund"
              rules="required|max:50"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-input
                outline
                v-model="form.Grund"
                label="Grund"
                name="Grund"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
              />
            </validation-provider>
            <validation-provider
              name="Datum"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-date-picker
                v-model="datum"
                disabledFuture
                label="Datum"
                name="Datum"
                :option="optionDatePicker"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
                outline
                @getValue="getPickersValue"
              />
            </validation-provider>
          </mdb-modal-body>
          <mdb-modal-footer>
              <mdb-btn color="grey lighten-1" @click.native="close">Zurück</mdb-btn>
              <mdb-btn
                color="primary"
                :disabled="loading"
                type="submit"
              >
                <template v-if="!loading">
                  Erstellen <mdb-icon icon="save" />
                </template>
                <template v-else>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Verladung
                </template>
              </mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbDatePicker,
    mdbInput,
    mdbIcon
  } from 'mdbvue';
  import utils from '@/mixins/Utils'

  export default {
    name: 'MedicineModal',
    mixins: [utils()],

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbDatePicker,
      mdbInput,
      mdbIcon
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        modal: false,
        loading: false,
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        datum: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        form: {
          Grund: '',
          Datum: '',
        },
        defaultForm: {
          Grund: '',
          Datum: '',
        }
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    methods: {
      close () {
        this.$refs.form.reset()
        this.datum = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),
        this.form = Object.assign({}, this.defaultForm)
        this.$emit('close')
      },

      save () {
        this.modal = false
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.datum = value
        }
      },

      saveMedicine() {

        this.form.Datum = this.formatDateY(this.datum)
        var userDate= new Date(this.form.Datum + ' ' + this.uhrzeit)
        this.form.Datum = this.serverDateFormat(userDate)
        this.form.AenderungAm =  this.serverDateFormat(userDate)
        this.form.AenderungVon = this.loginUser.username
        this.form.GastId = this.roomID

        this.loading = true
        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }

          this.$http.post('Bedarfsmedikation', this.form)
            .then(res => {
              if(res.data) {
                this.$notify.success({message: 'Neue Medikamente auf Abruf erfolgreich hinzugefügt', position: 'top right', closeButton: false, timeOut: 5000})
                this.close()
                this.save()
              }else {
                this.$notify.error({message: 'Fehler beim Hinzufügen neuer Medikamente auf Anfrage !!', position: 'top right', closeButton: false, timeOut: 5000})
              }
            })
            .finally(() => {
              this.loading = false
            })
        });
      }
    }
  }
</script>
